export enum ResourceAccessLevel {
  READ_ONLY = 'read_only',
  FULL = 'full',
}
